import React from "react";
import { FrameIcon, Text, Selector } from "../../../services/visualLibraryService";
import { LanguageWrapper, Spacer } from '../styles/Styled'
import { i18n } from "../../../services/i18nService";

export const Languages = ({ languagesList, onItemSelected, isFromSettingsPage }) => {
  return (
    <LanguageWrapper>
      <FrameIcon name="languageGlobe" />
      <Text rank="1" text={i18n.get(`global.language`)} size="xmedium" />
      <Spacer />
      <Selector
        items={languagesList}
        onItemSelected={onItemSelected}
        selectedIndex={languagesList.findIndex(item => item.active)}
        isFromSettingsPage={isFromSettingsPage}
        isFromLanguageSection={true}
        size={isFromSettingsPage ? "xmedium" : "default"}
      />
    </LanguageWrapper>
  );
};
